import classes from "./VerificationWarning.module.scss";

export interface VerificationSuggestion {
  /** Button copy, e.g. "Use donor@gmail.com". */
  label: string;
  onAccept: () => void;
}

export interface VerificationWarningProps {
  /** Translated, human-readable warning message. */
  message: string;
  /** Optional accept-the-correction action; omitted when Loqate offered none. */
  suggestion?: VerificationSuggestion | null;
  /** Dismiss / "keep mine" action — the check is non-blocking. */
  onDismiss: () => void;
  dismissLabel: string;
}

/**
 * Non-blocking, polite warning shown under a field when a Loqate data-quality
 * check flags it. The donor may accept a suggested correction (when present) or
 * dismiss and proceed with their original entry.
 */
export function VerificationWarning({
  message,
  suggestion,
  onDismiss,
  dismissLabel,
}: Readonly<VerificationWarningProps>) {
  // <output> carries an implicit ARIA "status" role (polite live region) — the
  // accessible, non-assertive announcement this non-blocking warning needs.
  return (
    <output className={classes.warning}>
      <p className={classes.message}>{message}</p>
      <div className={classes.actions}>
        {suggestion && (
          <button
            type="button"
            className={classes.accept}
            onClick={suggestion.onAccept}
          >
            {suggestion.label}
          </button>
        )}
        <button type="button" className={classes.dismiss} onClick={onDismiss}>
          {dismissLabel}
        </button>
      </div>
    </output>
  );
}
